import type { NextApiRequest } from 'next'

import { httpClient } from '@/services/http/httpClient'

type TokenHttpResponse = {
  token: {
    id: string
  }
}

type Params = {
  totalUsers: number
  expireIn?: Date
}

const getDomain = (req?: NextApiRequest): string => {
  if (req) {
    const protocol = req.headers['x-forwarded-proto'] || 'http'
    const host = req.headers.host
    return `${protocol}://${host}`
  } else if (typeof window !== 'undefined') {
    return `${window.location.protocol}//${window.location.host}`
  }

  return ''
}

export async function createInvitationLink(
  { expireIn, totalUsers }: Params,
  req?: NextApiRequest,
): Promise<string> {
  const { data } = await httpClient.post<TokenHttpResponse>(
    '/users/register-tokens',
    {
      expireIn,
      total_amount: totalUsers,
    },
  )

  const domain = getDomain(req)

  return `${domain}/invite/${data.token.id}`
}
